@if (messagesAreLoading()) {
    <!-- Loading state -->
    <div class="flex justify-center items-center h-full">
        <app-dot-loader-scale />
    </div>
} @else if (messages().length === 0 && !isAddingMessage()) {
    <!-- Empty state -->
    <!-- Home-rolled empty state because the EmptyStateComponent requires a mat-card, but we are cardless here. -->
    <div class="flex flex-col items-center mt-8">
        <img
            src="/assets/images/empty-state-svgs/empty-offers-contracts.svg"
            class="max-w-[106px]"
        />
        <span class="title-medium mt-6 mb-2">There aren’t any messages&hellip;</span>
        <span class="body-medium">Please <a href="add-message" class="text-blue-400" data-cy="fd-request-btn" (click)="addFirstMessage($event)">add a message</a> to get going.</span>
    </div>
} @else {
    <section class="messages max-w-[720px] mx-auto mt-6">
        <!-- New/Cancel button -->
        <button
            mat-button
            color="primary"
            (click)="isAddingMessage.set(!isAddingMessage())">
            @if (!isAddingMessage()) {
                <mat-icon class="mr-0">add</mat-icon>
            }
            {{isAddingMessage() ? 'Cancel' : 'New'}}
        </button>

        <div class="h-screen flex flex-col">
            <!-- Add new message rich text editor -->
            <app-add-message
                [dealId]="dealId()"
                [ngClass]="{ hidden: !isAddingMessage() }"
                (messageAdded)="isAddingMessage.set(false)"
                class="mt-4 mb-4" />

            <!-- List of messages -->
            <div class="messages-list flex-1 mt-4">
                @for (message of messages(); track message.id; let i = $index) {
                    <app-message
                        [message]="message"
                        [index]="i"
                        [dealId]="dealId()"
                        [messageIdToHighlight]="messageIdToHighlight() == message.id ? messageIdToHighlight() : undefined"
                        [replyIdToHighlight]="messageContainingReply()?.id == message.id ? replyIdToHighlight() : undefined" />
                }
            </div>
        </div>
    </section>
}